'use client';
import React, { useEffect, useState } from 'react';
import { getCookie } from 'typescript-cookie';
import SimilarItemsListCarousel from '@/components/customercenter-ui/components/home/similarItemsListCarousel';
import { COOKIE_KEYS } from '../../../../../constants/constant';
const SimilarItemsListCarouselTastic = (data: any) => {
  const [siteId, setSiteId] = useState<string>();
  const objectId = data?.data?.data?.dataSource?.product?.productId;
  const { text, maxSimilarProductsPerPage } = data?.data;

  useEffect(() => {
    const cookieSiteId = getCookie(COOKIE_KEYS.selectedSite) ?? 'ZBSite';
    setSiteId(cookieSiteId);
  }, []);

  return (
    <SimilarItemsListCarousel
      title={text}
      siteId={siteId}
      objectId={objectId}
      maxSimilarProductsPerPage={maxSimilarProductsPerPage}
      data={data}
    />
  );
};

export default SimilarItemsListCarouselTastic;
